module.exports = __webpack_public_path__ + "img/newsImg11-2.7a2961e9.png";